import { Helmet } from 'react-helmet-async';
import { useEffect, useState, useCallback } from 'react';
import { Grid, Container, Backdrop, CircularProgress, Typography, TextField, Box, InputAdornment } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import debounce from 'lodash/debounce';
import SearchIcon from '@mui/icons-material/Search';
import { DashboardComponent } from '../sections/@dashboard/app';
import { getDashboardData } from '../services/dashboardService';
import { isAdmin, removeDuplicatesFrmoArray } from '../utils/share';

export default function DashboardAppPage() {
  const [allUser, setAllUsers] = useState([]);
  const [pageState, setPageState] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');

  const fetchData = useCallback(async (page, searchTerm) => {
    setIsLoading(true);
    const allUserResponse = await getDashboardData(page, 5, searchTerm);
    setIsLoading(false);

    if (allUserResponse?.data.length < 5) {
      setHasMore(false);
    }

    if (page === 1) {
      setAllUsers(allUserResponse?.data ?? []);
    } else {
      setAllUsers((prev) => removeDuplicatesFrmoArray([...prev, ...(allUserResponse?.data ?? [])]));
    }
  }, []);

  const setNextPage = () => {
    setPageState((prev) => prev + 1);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      setSearch(value);
      setPageState(1);
      setHasMore(true);
      fetchData(1, value);
    }, 300),
    [fetchData]
  );

  useEffect(() => {
    fetchData(pageState, search);
  }, [fetchData, pageState, search]);

  return (
    <>
      {/* <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading && !allUser?.length}>
        <CircularProgress color="inherit" />
      </Backdrop> */}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
          mb: 2,
        }}
      >
        {isAdmin() && (
          <TextField
            id="outlined-basic"
            label="Search Team Member"
            variant="outlined"
            size="small"
            onChange={(e) => debouncedSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        )}
      </Box>

      <Grid item xs={12} md={12} lg={12}>
        <div style={{ minHeight: '400px' }}>
          <InfiniteScroll
            dataLength={allUser.length}
            next={setNextPage}
            hasMore={hasMore}
            loader={<CircularProgress style={{ display: 'block', margin: '20px auto' }} />}
            style={{ overflow: 'visible' }}
          >
            {allUser?.length !== 0 ? (
              <DashboardComponent title="Dashboard" list={allUser} />
            ) : (
              !isLoading && <h1>No data found</h1>
            )}
          </InfiniteScroll>
        </div>
      </Grid>
    </>
  );
}
